import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

// An icon button, using font awesome icons
//
// Props:
// `label`: The accessibility label for the button. Rendered as sr-only text. Required.
// `icon`: the icon name, without the `fa-` prefix. i.e., use `angle-left` for the `fa-angle-left` icon. Required.
// `size`: the size of the button, one of `xs`, `sm`, `md`, `lg`, `xl` or the `1x` to `10x`. Maps directly to `fa-XX` classes if set.
// `type`: the button type attribute, defaults to `button`
// `onClick`: the function to call when the button is clicked
//
// All other props are passed directly to the button element.
export const IconButton = ({
  label,
  icon,
  size,
  type = "button",
  ...props
}) => {
  const iconClasses = classNames(
    "fa-solid",
    size ? `fa-${size}` : "",
    `fa-${icon}`
  );

  return (
    <button type={type} {...props}>
      <i className={iconClasses} aria-hidden />
      <span className="sr-only">{label}</span>
    </button>
  );
};

IconButton.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  size: PropTypes.string,
  type: PropTypes.string,
};

export default IconButton;
